module.exports = __webpack_public_path__ + "img/forBarna2.4e2d44c5.png";